// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"755":"d7242da2","766":"7b6df863"}[chunkId] + ".chunk.js";
};